module.exports = __webpack_public_path__ + "static/media/facebook.9aab0496.svg";